import React from "react";
import { FileText, ShoppingBag, CreditCard, AlertCircle, Phone } from "lucide-react";

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-[#e5e7eb] px-6 py-12 flex flex-col items-center">
      {/* Heading */}
      <h1 className="text-5xl font-bold text-[#111827] mb-6">
        Terms & Conditions
      </h1>
      <p className="text-lg text-[#374151] max-w-3xl text-center mb-12">
        These Terms & Conditions govern your use of the{" "}
        <span className="font-semibold">Campus Canteen</span> online ordering
        application. By placing an order, you agree to these terms.
      </p>

      {/* Sections */}
      <div className="max-w-4xl w-full space-y-8">
        {/* Orders */}
        <div className="bg-white p-6 rounded-2xl shadow-lg">
          <div className="flex items-center mb-4">
            <ShoppingBag className="w-6 h-6 text-[#111827] mr-2" />
            <h2 className="text-2xl font-semibold text-[#111827]">
              Orders & Pickups
            </h2>
          </div>
          <p className="text-[#4b5563]">
            Orders must be placed through our official application. Once an
            order is confirmed, it cannot be canceled. Food should be picked up
            within the specified timeframe to ensure freshness.
          </p>
        </div>

        {/* Payments */}
        <div className="bg-white p-6 rounded-2xl shadow-lg">
          <div className="flex items-center mb-4">
            <CreditCard className="w-6 h-6 text-[#111827] mr-2" />
            <h2 className="text-2xl font-semibold text-[#111827]">
              Payments
            </h2>
          </div>
          <p className="text-[#4b5563]">
            Payments can be made online. All payments
            are final and non-refundable unless an error occurs on our part.
          </p>
        </div>

        {/* Responsibilities */}
        <div className="bg-white p-6 rounded-2xl shadow-lg">
          <div className="flex items-center mb-4">
            <FileText className="w-6 h-6 text-[#111827] mr-2" />
            <h2 className="text-2xl font-semibold text-[#111827]">
              Responsibilities
            </h2>
          </div>
          <p className="text-[#4b5563]">
            We strive to provide accurate descriptions and availability of food
            items. However, availability may vary based on daily stock. Users
            are responsible for providing correct order details.
          </p>
        </div>

        {/* Limitations */}
        <div className="bg-white p-6 rounded-2xl shadow-lg">
          <div className="flex items-center mb-4">
            <AlertCircle className="w-6 h-6 text-[#111827] mr-2" />
            <h2 className="text-2xl font-semibold text-[#111827]">
              Limitations of Liability
            </h2>
          </div>
          <p className="text-[#4b5563]">
            The canteen will not be liable for delays or issues caused by
            technical errors, network issues, or user mistakes in placing
            orders.
          </p>
        </div>

        {/* Contact */}
        <div className="bg-white p-6 rounded-2xl shadow-lg">
          <div className="flex items-center mb-4">
            <Phone className="w-6 h-6 text-[#111827] mr-2" />
            <h2 className="text-2xl font-semibold text-[#111827]">
              Contact Us
            </h2>
          </div>
          <p className="text-[#4b5563]">
            For questions about these Terms & Conditions, please contact us at:{" "}
            <br />
            <span className="font-medium">grabgrubcontact@gmail.com</span>
          </p>
        </div>
      </div>

      {/* Closing Note */}
      <p className="mt-12 text-[#374151] text-center max-w-2xl">
        By using our app, you agree to follow these Terms & Conditions. We may
        update them from time to time to reflect changes in our services.
      </p>
    </div>
  );
};

export default TermsAndConditions;
